import { Component, ViewChild, OnInit } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { MdPaginator,MdSnackBar, DateAdapter } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { BrogliaccioDistintaModel } from './../../models/brogliacci/brogliaccio-distinta.model';
import { BrogliacciService } from './../../services/brogliacci.service';
import { BrogliaccioSearchModel } from "../../models/brogliacci/brogliaccio-search.model";
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { IncassiService } from "../../services/incassi.service";
import { DistinteIncassiService } from "../../services/distinte-incassi.service";
import { DistintaModel } from '../../models/brogliacci/distinta-model';

@Component({
  selector: 'app-distinte-incassi-list',
  templateUrl: './distinte-incassi-list.component.html',
  styleUrls: ['./distinte-incassi-list.component.css']
})

export class DistinteIncassiListComponent implements OnInit {
  isLoading: boolean;
  displayedColumns = ['id', 'dataCreazione', 'stato', 'totaleValuta', 'totaleAssegni', 'numerodistinta', 'tokenDettagli', 'tokenElimina'];
  dataSource: DistintaIncassiDataSource | null;
  distintaIncassi: BrogliaccioDistintaModel[];
  model: BrogliaccioSearchModel = null;
  STATI_DISTINTA: DizionarioModel[];
  dataDal?: Date;
  dataAl?: Date;

  constructor(
    private snackBar: MdSnackBar,
    private _distintaService: DistinteIncassiService,
    private _brogliacciService: BrogliacciService,
    private _dateAdapter:DateAdapter<Date>
  ) { 
    _dateAdapter.setLocale('it-IT');
    this.isLoading=true;
  }

  @ViewChild(MdPaginator) paginator: MdPaginator;

  ngOnInit() {
    this.model = new BrogliaccioSearchModel();
    let emptyChoice=new DizionarioModel();
    emptyChoice.codice="";
    emptyChoice.descrizione="Tutti";
    this._distintaService.getStati().subscribe(
      data => {
        data.splice(0,0,emptyChoice);
        this.STATI_DISTINTA = data;
      },
      error => {
        this.showError("Errore durante la procedura di caricamento degli stati");
      }
    );
    //initDatePicker();

    //fai vedere subito i confermati
    this.model.idstato=2;
    this.dataSource = new DistintaIncassiDataSource(this._distintaService, this.paginator, this.model,this);
  }

  /* RICERCA */
  search() {
    this.model.dataAl= this.dataAl;
    this.model.dataDal= this.dataDal;
    this.isLoading=true;
    this.dataSource = new DistintaIncassiDataSource(this._distintaService, this.paginator, this.model,this);
  }

  /* ELIMINAZIONE DI UN DISTINTA */
  eliminaDistintaIncassi(model: DistintaModel) {
    //elimino la distinta (dalla lista) e ricarico la ricerca
    this._distintaService.eliminaDistinta(model).subscribe(
      data => {
        this.showInfo("Eliminazione avvenuta correttamente");
        this.search();
      },
      error => {
        this.showError("Errore durante la procedura di eliminazione della distinta");
        return false;
      }
    );
  }

  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 2000 });
  }
  public getDistintaFilteredList(model:BrogliaccioSearchModel):Observable<BrogliaccioDistintaModel[]> {
    let result=this._distintaService.getFilteredList(model);
    this._distintaService.getFilteredList(model).subscribe(
      data=> {
        this.isLoading=false;
      }
      
    );
    return result;
  }
}



/* DATA SOURCE - lista distinta */
export class DistintaIncassiDataSource extends DataSource<any> {
  constructor(private _distintaService: DistinteIncassiService,
     private _paginator: MdPaginator, private model: BrogliaccioSearchModel,private originModel:DistinteIncassiListComponent) {
    super();
  }
  connect(): Observable<BrogliaccioDistintaModel[]> {
    return this.originModel.getDistintaFilteredList(this.model);
  }
  disconnect() { }

}




// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/distinteincassi/distinte-incassi-list.component.ts